/* global document */

import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import Widget from './jordanReservationPricing/JordanReservationPricing';

const JordanReservationPricing = (props) =>
  ReactDOM.createPortal(
    <>
      <Widget slug={props.slug} />
    </>,
    document.getElementById('c7-reservation-pricing-jv')
  );

export default JordanReservationPricing;
